import { useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom'
import { 
  PiHouse, 
  PiHouseFill, 
  PiFolderSimple, 
  PiFolderSimpleFill 
} from "react-icons/pi";
import { BsPerson, BsFillPersonFill } from "react-icons/bs";
import { UserContext } from '../context/UserContext'

const NavBar = () => {
  const location = useLocation()
  const { loggedInUser } = useContext(UserContext)

  return (
    <nav>
      {loggedInUser ? (
        <ul>
          <li>
            <NavLink 
              to={loggedInUser ? "/prompts" : "/"} 
              className={`nav-item ${location.pathname === "/" ? "active" : ""}`}
            >
              {location.pathname === "/" || location.pathname === "/prompts" ? (
                <PiHouseFill />
              ) : (
                <PiHouse />
              )}
              <span>Home</span>
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/portfolio" 
              className={`nav-item ${location.pathname === "/portfolio" || location.pathname.startsWith("/artwork") ? "active" : ""}`}
            >
              {location.pathname === "/portfolio" || location.pathname.startsWith("/artwork") ? (
                <PiFolderSimpleFill />
              ) : (
                <PiFolderSimple />
              )}
              <span>Portfolio</span>
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/profile" 
              className={`nav-item ${location.pathname === "/profile" ? "active" : ""}`}
            >
              {location.pathname === "/profile" ? (
                <BsFillPersonFill />
              ) : (
                <BsPerson />
              )}
              <span>Profile</span>
            </NavLink>
          </li>
        </ul>
      ) : (  
        null
      )}
    </nav>
  )
}

export default NavBar